import React from 'react';
import PropTypes from 'prop-types';
import { getTalents, mapTalentToSpecialRibbonProps } from '../fichaHelper';
import SpecialRibbon from '../../RibbonNew/SpecialRibbon';

var NOOP = function() {};

class VCardTalents extends React.PureComponent {
    constructor(props) {
        super(props);
        // Cache para evitar recalcular talents y ribbonProps en cada render
        this._cachedTalents = null;
        this._cachedRibbonProps = null;
        this._prevRoles = undefined;
        this._prevExternalrole = undefined;
        this._prevHandleTalentClick = undefined;
        this._prevContentName = undefined;
    }

    componentWillUnmount() {
        this._cachedTalents = null;
        this._cachedRibbonProps = null;
    }

    render(){
        const {roles, externalrole, setMetricsEvent, handleTalentClick, user, content_name } = this.props;

        // Cache talents solo si cambiaron los inputs
        if (roles !== this._prevRoles || externalrole !== this._prevExternalrole || handleTalentClick !== this._prevHandleTalentClick) {
            this._prevRoles = roles;
            this._prevExternalrole = externalrole;
            this._prevHandleTalentClick = handleTalentClick;
            this._cachedTalents = externalrole ? externalrole : getTalents(roles, handleTalentClick);
            // Invalidar ribbonProps también
            this._prevContentName = undefined;
        }

        const talents = this._cachedTalents;
        if(!Array.isArray(talents) || talents.length === 0){
            return null;
        }

        // Cache ribbonProps solo si cambió talents o content_name
        if (content_name !== this._prevContentName) {
            this._prevContentName = content_name;
            this._cachedRibbonProps = mapTalentToSpecialRibbonProps(talents, content_name, this.props.thereAreRecommendations, this.props.thereAreEpisodes);
        }

        return (
            <div className="vcard-talents">
                <SpecialRibbon
                    {...this._cachedRibbonProps}
                    user={user}
                    setMetricsEvent={setMetricsEvent}
                />
            </div>
        )
    }
}

VCardTalents.propTypes = {
    roles: PropTypes.array.isRequired,
    externalrole: PropTypes.object,
    setMetricsEvent: PropTypes.func.isRequired,
    handleTalentClick: PropTypes.func.isRequired
}

VCardTalents.defaultProps = {
    roles: [],
    externalrole: null,
    setMetricsEvent: NOOP,
    handleTalentClick: NOOP
}

export default VCardTalents;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardTalents.jsx